<template>
	<div class="stats">
		<h1 class="hero">Estadísticas</h1>

		<h2>Pagos (mes natural)</h2>
		<div class="stats-group">
			<div class="small-stats">
				<small-stat
					class="small-stat"
					:data="{
						number: `${stats.paymentAmount / 100}€`,
						name: 'Total',
						icon: 'mdi-cash',
					}"
				></small-stat>

				<small-stat
					class="small-stat"
					:data="{
						number: stats.paymentCount,
						name: 'Pagos completados',
						icon: 'mdi-credit-card-check',
					}"
					color="success"
				></small-stat>

				<small-stat
					class="small-stat"
					:data="{
						number: stats.rejectedPaymentCount,
						name: 'Pagos rechazados',
						icon: 'mdi-credit-card-remove',
					}"
					color="error"
				></small-stat>

				<small-stat
					class="small-stat"
					:data="{
						number: stats.pendingPaymentCount,
						name: 'Pagos pendientes',
						icon: 'mdi-credit-card-clock',
					}"
					color="info lighten-2"
				></small-stat>
			</div>
			<div class="other-stats">
				<v-card class="rounded-lg stats-card">
					<v-sheet color="secondary">
						<h2 class="accent--text graph-title">
							Pagos realizados este mes
						</h2>
						<v-sparkline
							:labels="stats.paymentsPerDay.days"
							:value="stats.paymentsPerDay.payments"
							color="accent"
							line-width="2"
							padding="16"
							smooth
							show-labels
						></v-sparkline>
					</v-sheet>
				</v-card>

				<!-- <v-card class="rounded-lg stats-card">
					<v-sheet color="secondary">
						<h2 class="error--text graph-title">
							Pagos rechazados este mes
						</h2>
						<v-sparkline
							:labels="stats.paymentsPerDay.days"
							:value="stats.paymentsPerDay.rejected"
							color="error"
							line-width="2"
							padding="16"
							smooth
							show-labels
						></v-sparkline>
					</v-sheet>
				</v-card> -->
			</div>
		</div>

		<h2>Carreras</h2>
		<div class="stats-group">
			<div class="small-stats">
				<small-stat
					class="small-stat"
					:data="{
						number: stats.raceCount,
						name: 'Carreras activas',
						icon: 'mdi-run',
					}"
				></small-stat>

				<small-stat
					class="small-stat"
					:data="{
						number: stats.freeRaceCount,
						name: 'Carreras Gratis',
						icon: 'mdi-currency-usd-off',
					}"
				></small-stat>

				<small-stat
					class="small-stat"
					:data="{
						number: stats.paidRaceCount,
						name: 'Carreras de pago',
						icon: 'mdi-currency-usd',
					}"
				></small-stat>
			</div>
			<div class="other-stats">
				<v-card class="content rounded-lg stats-card">
					<h1>Últimas carreras creadas</h1>

					<ul>
						<li v-for="race in stats.lastRaces" :key="race.id">
							{{ race.name }}
						</li>
					</ul>
				</v-card>
			</div>
		</div>

		<h2>Usuarios</h2>
		<div class="stats-group">
			<div class="small-stats">
				<small-stat
					class="small-stat"
					:data="{
						number: stats.userCount,
						name: 'Usuarios Registrados',
						icon: 'mdi-account-check',
					}"
				></small-stat>

				<small-stat
					class="small-stat"
					:data="{
						number: stats.verificationPendingUserCount,
						name: 'Usuarios sin verificar',
						icon: 'mdi-account-alert',
					}"
					color="warning"
				></small-stat>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from "axios";

	import SmallStat from "../../components/admin/stats/SmallStat";
	export default {
		components: {
			SmallStat,
		},
		data: () => ({
			stats: {
				paymentsPerDay: {
					days: [1],
				},
			},
		}),
		mounted() {
			this.fetchStats();
		},
		methods: {
			async fetchStats() {
				try {
					const response = await axios.get("/admin/stats");
					this.stats = response.data;
				} catch (error) {
					if (error.response && error.response.status === 401) {
						this.$router.push({ name: "AdminLogin" });
					} else {
						this.$emit("snackbar-event", {
							color: "error",
							text:
								"Ha ocurrido un error, vuelva a intentarlo más tarde",
						});
					}
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.stats {
		padding: 2em;

		.hero {
			font-size: 4em;
			font-weight: 400;
			margin-bottom: 0.5em;
		}
	}
	.stats-group {
		display: flex;
		flex-direction: column;

		&:not(:last-of-type) {
			margin-bottom: 4em;
		}

		.small-stats {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
			column-gap: 2em;
			row-gap: 2em;
		}

		.other-stats {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
			column-gap: 2em;
			row-gap: 2em;
			margin-top: 2em;

			.stats-card {
				flex: 1;

				.graph-title {
					text-align: center;
					padding: 1em;
				}
			}

			.content {
				width: 100%;
				padding: 2em;

				ul {
					li {
						font-size: 1em;
						margin-top: 1em;
					}
				}
			}
		}
	}
</style>
